import * as React from 'react'
import { useState } from 'react'

import {
  Box,
  CollapsableCard,
  Tag,
  Text,
  TogglerCheckbox,
} from '@factorialco/deprecated-design-system'
import { PerformanceReviewerStrategiesStrategyEnum } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import { reviewTypeOptions } from './reviewTypeOptions'

interface Props {
  reviewerStrategies: PerformanceReviewerStrategiesStrategyEnum[]
  disabled: boolean
  onChange: (strategies: PerformanceReviewerStrategiesStrategyEnum[]) => void
}

export const ReviewerTypeSection = ({ reviewerStrategies, onChange, disabled = false }: Props) => {
  const [updatedReviewerStrategies, newReviewerStrategies] = useState(new Set(reviewerStrategies))

  // update reviewer strategies mutation
  const onToggleReviewType = async (value: PerformanceReviewerStrategiesStrategyEnum) => {
    if (updatedReviewerStrategies.has(value)) {
      updatedReviewerStrategies.delete(value)
    } else {
      updatedReviewerStrategies.add(value)
    }

    onChange(Array.from(updatedReviewerStrategies))
  }

  return (
    <Box gap="s16">
      {reviewTypeOptions().map((reviewType) => (
        <CollapsableCard
          key={reviewType.value}
          open={false}
          Card={
            <Box gap="s4">
              <Box flexDirection="row" justifyContent="spaceBetween">
                <Box onClick={() => onToggleReviewType(reviewType.value)}>
                  <Text.Normal weight="medium">{reviewType.label}</Text.Normal>
                </Box>
                {!reviewType.disabled && (
                  <TogglerCheckbox
                    value={reviewerStrategies?.includes(reviewType.value) ?? false}
                    onChange={() => onToggleReviewType(reviewType.value)}
                    disabled={disabled}
                    aria-label={reviewType.label}
                  />
                )}
                {reviewType.disabled && (
                  <Tag type="malibu">{i18n.t('performance_process.reviews.coming_soon')}</Tag>
                )}
              </Box>
              <Text.Normal>{reviewType.description}</Text.Normal>
            </Box>
          }
          Content={<></>}
        />
      ))}
    </Box>
  )
}
